// Auto-generated normalizer for table: Cat_Propiedades
export function catPropiedadesNormalize(row) {
  return {
    idPropiedad: row.idPropiedad ?? row.IdPropiedad ?? row['IdPropiedad'] ?? 0,
    propiedad: row.propiedad ?? row.Propiedad ?? row['Propiedad'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
